import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../link/nn-link.js';
import assetsPath from '../../index.js';

/**
 * The SocialMedia molecule contains social media icons and links to pages of Nordnet.
 *
 * title - The text display before icons.
 * boldTitle - Display title in bold font or not.
 * uppercaseTitle - Display title uppercase or not.
 * breakLineInSmallScreen - Determine if should break line in small screen (<=767px) or not.
 */
@customElement('nn-social-media')
export class SocialMedia extends LitElement {
  static styles = css`
    .hidden,
    .show-off {
      display: none;
    }
    .footer-social {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: var(--nn-social-media_footer-social_gap, 8px);
      margin: 0;
    }
    .footer-social--title {
      font-family: 'font-light';
      color: var(--nn-social-media_footer-social--title_color, #000);
      font-size: var(--nn-social-media_footer-social--title_font-size, 0.75em);
      font-weight: 400;
    }
    .footer-social--title.bold {
      font-family: 'font-heavy';
    }
    .footer-social--title.uppercase {
      text-transform: uppercase;
    }
    .footer-social--text {
      margin: 0;
    }

    @media (max-width: 767px) {
      .footer-social--title.break-line-in-small-screen {
        flex-basis: auto;
        flex-shrink: 0;
        width: 100%;
        text-align: center;
      }
    }
  `;

  @property({ type: String }) title = '';

  @property({ type: String }) boldTitle = false;

  @property({ type: String }) uppercaseTitle = false;

  @property({ type: Boolean }) breakLineInSmallScreen = false;

  render() {
    return html`
      <dl class="footer-social">
        <dt
          class="footer-social--title ${this.boldTitle ? 'bold' : ''} ${this
            .breakLineInSmallScreen
            ? 'break-line-in-small-screen'
            : ''} ${this.uppercaseTitle ? 'uppercase' : ''}"
        >
          ${this.title}
        </dt>
        <dd class="footer-social--text">
          <a
            id="footer-youtube"
            class="footer-social--link"
            title="Youtube"
            href="https://www.youtube.com/c/nordnet"
            target="_blank"
            rel="nofollow"
          >
            <img
              width="24"
              height="24"
              src="${assetsPath}/icons/social-youtube-red-24.svg"
              alt="Youtube"
              aria-hidden="true"
              loading="lazy"
            />
            <span class="hidden">${this.title} Youtube</span>
          </a>
        </dd>
        <dd class="footer-social--text">
          <a
            id="footer-twitter"
            class="footer-social--link"
            title="X"
            href="https://x.com/NordnetOFFICIEL"
            target="_blank"
            rel="nofollow"
          >
            <img
              width="24"
              height="24"
              src="${assetsPath}/icons/social-twitter-blue-24.svg"
              alt="X"
              aria-hidden="true"
              loading="lazy"
            />
            <span class="hidden">${this.title} X</span>
          </a>
        </dd>
        <dd class="footer-social--text">
          <a
            id="footer-facebook"
            class="footer-social--link"
            title="Facebook"
            href="https://www.facebook.com/NordnetOFFICIEL"
            target="_blank"
            rel="nofollow"
          >
            <img
              width="24"
              height="24"
              src="${assetsPath}/icons/social-facebook-blue-24.svg"
              alt="Facebook"
              aria-hidden="true"
              loading="lazy"
            />
            <span class="hidden">${this.title} Facebook</span>
          </a>
        </dd>
        <dd class="footer-social--text">
          <a
            id="footer-linkedin"
            class="footer-social--link"
            title="LinkedIn"
            href="https://www.linkedin.com/company/nordnet-officiel/mycompany/"
            target="_blank"
            rel="nofollow"
          >
            <img
              width="24"
              height="24"
              src="${assetsPath}/icons/social-linkedin-blue-24.svg"
              alt="LinkedIn"
              aria-hidden="true"
              loading="lazy"
            />
            <span class="hidden">${this.title} linkedIn</span>
          </a>
        </dd>
      </dl>
    `;
  }
}
